<template>
  <div>
    <div v-if="cards.length === 0" class="cards_empty">{{ emptyText }}</div>
    <div class="cards_list">
      <div class="card_item" v-for="card in cards" :key="card.id">
        <div class="card_data">
          <div class="card_name">
            <template v-if="card.CardType === 'sbp'">СБП</template>
            <template v-else>{{ cardTypeLabel(card) }} &bull; {{ maskedPan(card) }}</template>
          </div>
          <div v-if="hasExpiry(card)" class="card_expires">
            Действует до {{ card.CardExpMonth }}/{{ card.CardExpYear }}
          </div>
        </div>
        <div class="card_actions">
          <template v-if="confirmDeleteId === card.id">
            <span class="card_confirm_text">Удалить карту?</span>
            <div class="card_confirm_buttons">
              <div class="button_cancel" @click="confirmDeleteId = null"><p>Нет</p></div>
              <div class="button_separator">|</div>
              <div class="button_accept" @click="confirmDelete(card)"><p>Да</p></div>
            </div>
          </template>
          <template v-else>
            <button
                type="button"
                class="btn btn-white card_delete_btn"
                :disabled="deletingId === card.id"
                @click="confirmDeleteId = card.id"
            >
              Удалить
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardsList',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: 'Привязанных карт нет',
    },
    deletingId: {
      type: Number,
      default: null,
    },
  },
  emits: ['delete-card'],
  data() {
    return {
      confirmDeleteId: null,
    }
  },
  methods: {
    confirmDelete(card) {
      this.confirmDeleteId = null
      this.$emit('delete-card', card.id)
    },
    cardTypeLabel(card) {
      return card.CardType && card.CardType !== '-' ? card.CardType : 'Карта'
    },
    maskedPan(card) {
      const firstSix = card.CardFirstSix && card.CardFirstSix !== '-' ? card.CardFirstSix : '******'
      const lastFour = card.CardLastFour || card.CardlastFour
      return firstSix + '******' + (lastFour && lastFour !== '-' ? lastFour : '****')
    },
    hasExpiry(card) {
      return Boolean(card.CardExpMonth) && card.CardExpMonth !== '-'
          && Boolean(card.CardExpYear) && card.CardExpYear !== '-'
    },
  },
}
</script>
